<template>
  <div class="container-fluid bg-dark px-0" id="headerContainer">
    <div class="row gx-0">
      <div class="col-lg-2 bg-dark d-none d-lg-block">
        <router-link to="/anasayfa" class="navbar-brand w-100 h-100 m-0 p-0 d-flex align-items-center justify-content-center">
          <!-- Logo Görseli -->
          <img :src="logo" alt="AĞ-DER Logo" style="max-height: 40px;" />
        </router-link>
      </div>
      <div class="col-lg-10">
        <nav class="navbar navbar-expand-lg bg-dark navbar-dark p-3 p-lg-0">
          <router-link to="/anasayfa" class="navbar-brand d-block d-lg-none">
            <img :src="logo" alt="AĞ-DER Logo" style="max-height: 40px;" />
          </router-link>
          <button type="button" class="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse justify-content-between" id="navbarCollapse">
            <div class="navbar-nav mr-auto py-0">
              <router-link to="/anasayfa" @click="closeNavbar" class="nav-item nav-link" active-class="active">Anasayfa</router-link>
              <router-link to="/firmalar" @click="closeNavbar" class="nav-item nav-link" active-class="active">Firmalarımız</router-link>
              <router-link to="/hakkimizda" @click="closeNavbar" class="nav-item nav-link" active-class="active">Hakkımızda</router-link>
              <router-link to="/etkinlikler" @click="closeNavbar" class="nav-item nav-link" active-class="active">Etkinliklerimiz</router-link>
              <router-link to="/hizmetlerimiz" @click="closeNavbar" class="nav-item nav-link" active-class="active">Hizmetlerimiz</router-link>
              <router-link to="/kurucular" @click="closeNavbar" class="nav-item nav-link" active-class="active">Kurucular</router-link>
              <router-link to="/kurullar" @click="closeNavbar" class="nav-item nav-link" active-class="active">Kurullar</router-link>
              <router-link to="/sss" @click="closeNavbar" class="nav-item nav-link" active-class="active">S.S.S</router-link>
              <a href="tel:+905079217404" @click="closeNavbar" class="nav-item nav-link">İletişim</a>
              <a :href="whatsappJoinUrl" target="_blank" rel="noopener" @click="closeNavbar" class="nav-item nav-link join-link">Katıl</a>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { Collapse } from 'bootstrap'
import logo from '@/assets/logo_dark.png'

export default {
  name: 'NavBar',
  data() {
    return {
      logo,
      whatsappJoinUrl: `https://wa.me/905079217404?text=${encodeURIComponent('Derneğinize websitesinden katıldım, herkese merhabalar.')}`
    }
  },
  methods: {
    closeNavbar() {
      const navbarCollapse = document.getElementById('navbarCollapse')
      if (navbarCollapse && navbarCollapse.classList.contains('show')) {
        const collapse = Collapse.getInstance(navbarCollapse) || new Collapse(navbarCollapse, { toggle: false })
        collapse.hide()
      }
    }
  }
}
</script>
